export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { name: 'Home', id: 'home' },
    { name: 'About Us', id: 'about' },
    { name: 'Services', id: 'services' },
    { name: 'VPN Product', id: 'vpn' },
    { name: 'Contact', id: 'contact' }
  ];

  const socialLinks = [
    { icon: 'ri-linkedin-fill', url: '#' },
    { icon: 'ri-twitter-x-fill', url: '#' },
    { icon: 'ri-facebook-fill', url: '#' },
    { icon: 'ri-instagram-fill', url: '#' }
  ];

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/52bb30dd-0a73-498d-874f-57d934b0de4c.png" 
                alt="IGANA Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-teal-50 text-sm leading-relaxed mb-6 max-w-xs">
              Leading provider of secure VPN solutions and innovative applications, dedicated to protecting your digital privacy and enhancing your online experience.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/30 hover:border-white hover:bg-white/10 transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-teal-50 text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide mb-4">Contact Info</h3>
            <div className="space-y-4">
              <div>
                <p className="text-xs text-teal-100 uppercase mb-1">Email</p>
                <a href="mailto:help@iganadoo.com" className="text-white text-sm hover:text-teal-100 transition-colors cursor-pointer">
                  help@iganadoo.com
                </a>
              </div>
              <div>
                <p className="text-xs text-teal-100 uppercase mb-1">Phone</p>
                <a href="tel:+18576783755" className="text-white text-sm hover:text-teal-100 transition-colors cursor-pointer">
                  +1 8576783755
                </a>
              </div>
              <div>
                <p className="text-xs text-teal-100 uppercase mb-1">Address</p>
                <p className="text-white text-sm leading-relaxed">
                  Ivana Plemenitog Zajca 18<br />
                  22300 Knin<br />
                  Croatia
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-teal-50 text-sm">
            © 2025 IGANA d.o.o. All rights reserved
          </p>
          <div className="flex gap-8">
            <a href="#" className="text-teal-50 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="#" className="text-teal-50 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-teal-50 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
